import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { PopupInformation } from './PopupInformation';

export const INFORMATION_POPUP = Symbol('INFORMATION');

const DEFAULT_BUTTONS = {
  confirm: 'Ok',
};

export const useInformationPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(INFORMATION_POPUP, PopupInformation);
  });

  return useCallback(
    (options) => {
      const { title, content, buttons, ...restOptions } = options;
      const buttonOptions = { ...DEFAULT_BUTTONS, ...buttons };

      return new Promise((resolve) => {
        popups.openPopup(INFORMATION_POPUP, {
          title,
          content,
          submitLabel: buttonOptions.submitLabel,
          additionalActionLabel: buttonOptions.additionalActionLabel,
          ...restOptions,
          onClose: (reason) => {
            popups.closePopup(INFORMATION_POPUP);
            resolve(reason);
          },
        });
      });
    },
    [popups]
  );
};
